import { Grid, GridColumn, GridRow, Icon, Popup } from "semantic-ui-react";

import { useTyrePositionName } from "hooks";
import { QuestionResultStatus } from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/components";
import {
  getTyreDescription,
  getTyreSize
} from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/components/TyreQuestionResults/utils";
import { CustomerCommunicationReplacementTyre } from "modules/AppointmentDetails/components/CustomerCommunicationModal/components/CustomerCommunicationReplacements/components";
import { getTyreSeasonIcon } from "utils/common";

import type { STATUS_IDENTIFIERS, VehicleTyre } from "models";

type CustomerCommunicationTyreTableItemsProps = {
  vehicleTyre: VehicleTyre;
  isLastInGroup: boolean;
  showVat: boolean;
  appointment_status_identifier: STATUS_IDENTIFIERS;
};

export const CustomerCommunicationTyreTableItems = ({ vehicleTyre, isLastInGroup, showVat, appointment_status_identifier }: CustomerCommunicationTyreTableItemsProps) => {
  const tyrePositionName = useTyrePositionName(vehicleTyre.position);

  const { tyre, question_result_remark, question_result_status } = vehicleTyre;
  const tyreDescription = getTyreDescription(tyre);

  return (
    <div className="CustomerCommunicationTyreTableItem">
      <Grid>
        <GridRow className={`CustomerCommunicationTyreTableItem__row ${isLastInGroup ? "is-last" : ""}`}>
          <GridColumn width={2}>
            <div className="tyre-position-container">
              <span>{tyrePositionName}</span>
            </div>
          </GridColumn>
          <GridColumn width={2}>
            <div className="tyre-season-container">
              {tyre && <Icon className={getTyreSeasonIcon(tyre.season)} />}
              <p>{getTyreSize(tyre)}</p>
            </div>
          </GridColumn>
          <GridColumn width={3}>
            <Popup hoverable content={tyreDescription} trigger={<p className="-truncated-text">{tyreDescription}</p>} disabled={!tyreDescription} />
          </GridColumn>
          <GridColumn width={2}>
            <Popup hoverable content={tyre?.manufacturer} trigger={<p className="-truncated-text">{tyre?.manufacturer}</p>} />
          </GridColumn>
          <GridColumn width={1}>{vehicleTyre.profile ? `${vehicleTyre.profile} mm` : ""}</GridColumn>
          <GridColumn width={3}>
            <Popup
              content={question_result_remark}
              trigger={<p className="-truncated-text">{question_result_remark}</p>}
              hoverable
              position="top left"
              disabled={!question_result_remark}
            />
          </GridColumn>
          <GridColumn width={1} />
          <GridColumn width={2} textAlign="right">
            <div className="icons-container">
              {question_result_status !== null && (
                <div className="question_result_status">
                  <QuestionResultStatus status={question_result_status} />
                </div>
              )}
            </div>
          </GridColumn>
        </GridRow>
      </Grid>

      {vehicleTyre.replacements?.map((replacement, idx, arr) => (
        <CustomerCommunicationReplacementTyre
          key={replacement.id}
          replacement={replacement}
          showVat={showVat}
          appointment_status_identifier={appointment_status_identifier}
          isLast={isLastInGroup && idx === arr.length - 1}
        />
      ))}
    </div>
  );
};
